//
//
//
//
//
//
//
//
//

import { ALARM_SEVERITIES_CONFIG } from '../../components/helpers.js'

export default {
  name: 'TableCellAlarm',
  props: {
    value: {
      type: [Object, String],
      required: true
    }
  },
  computed: {
    isObject: function () {
      return this.value != null && typeof this.value === 'object'
    },
    severityConfig: function () {
      let config = null
      if (this.isObject && this.value.severity != null) {
        config = ALARM_SEVERITIES_CONFIG[this.value.severity]
      }
      if (!config) {
        config = ALARM_SEVERITIES_CONFIG.critical
      }
      return config
    },
    message: function () {
      if (this.isObject) {
        return this.value.message
      }
      return this.value
    }
  }
}
